import { MutationTree } from 'vuex'
import { ProductsState } from './state'

export enum ProductsMutationTypes {
  GetAllProductsSuccess = '[Products Mutation] Get All Products Success',
  CalculatePayloadSuccess = '[Products Mutation] Calculate Payload Success',
  BuyPayloadSuccess = '[Products Mutation] Buy Payload Success',
}

export const mutations: MutationTree<ProductsState> = {
  [ProductsMutationTypes.GetAllProductsSuccess](state, payload: { data: [] }) {
    state.products = payload.data
  },

  [ProductsMutationTypes.CalculatePayloadSuccess](state, payload) {
    state.calculate = payload
  },

  [ProductsMutationTypes.BuyPayloadSuccess](state, payload) {
    state.getPaymentLink = payload.url
  },
}
